import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pt: '20px',
  },
  confirmContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'pharmacy.requestedLight',
    paddingX: '12px',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    paddingY: '4px',
  },
  label: {
    ml: '8px',
    fontSize: 12,
    fontWeight: '600',
    color: 'pharmacy.requested',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
